import FiltersFormBar from "./FiltersFormBar";

export default class RemovableFilters {

    private buttons: Array<HTMLElement> = [];
    private allButton: HTMLElement | null;
    private filtersForm: FiltersFormBar;

    public constructor(filtersForm: FiltersFormBar) {
        this.buttons = Array.from(document.querySelectorAll('div[data-element]'))
        this.allButton = document.querySelector('span[data-element-all]');
        this.filtersForm = filtersForm;
        this.init();
    }

    private init() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                let fieldName = button.getAttribute("data-element")!;
                let fieldValue = button.getAttribute("data-value")!;
                this.removeFilter(fieldName, fieldValue);
            });
        });
        if (this.allButton) {
            this.allButton.addEventListener('click', () => {
                this.buttons.forEach((button) => {
                    let fieldName = button.getAttribute("data-element")!;
                    let fieldValue = button.getAttribute("data-value")!;
                    this.removeFilter(fieldName, fieldValue);
                });
            });
        }
    }

    private removeFilter(name: String, value: String) {
        name.split("-").forEach((splitName) => {
            let filters = this.getFilters(splitName, value);
            filters.forEach((filter) => {
                // @ts-ignore
                filter.disabled = true;
            });
        });
        setTimeout( () => this.filtersForm.submit(), 0);
    }

    private getFilters(splitName: string, value: String) {
        if (value) {
            return this.filtersForm.getFilters('[name="' + splitName + '"][value="' + value + '"]')
        }

        return this.filtersForm.getFilters('[name="' + splitName + '"]');
    }
}